/**
 * API Key 服务：列表 / 创建 / 更新 / 删除。
 *
 * 创建接口会返回一次性明文 `keyPlain`，前端应仅在创建成功时展示一次。
 *
 * @module services/apikey
 */
import type { ApiKey } from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 创建 API Key 时返回的结果（含一次性明文）。 */
export type ApiKeyWithSecret = ApiKey & { keyPlain: string };

/** 创建 API Key 入参。 */
export interface CreateApiKeyInput {
  name: string;
  quotaLimit?: string | null;
  expiresAt?: string | null;
}

/** 更新 API Key 入参。 */
export interface UpdateApiKeyInput {
  status?: ApiKey['status'];
}

/** 列出当前用户 API Key。 */
export async function listApiKeys(): Promise<ApiKey[]> {
  return request<ApiKey[]>({ method: 'GET', url: API.apikey.list });
}

/** 创建 API Key（返回明文一次）。 */
export async function createApiKey(
  input: CreateApiKeyInput,
): Promise<ApiKeyWithSecret> {
  return request<ApiKeyWithSecret>({
    method: 'POST',
    url: API.apikey.create,
    data: input,
  });
}

/** 更新 API Key（如启用/禁用）。 */
export async function updateApiKey(
  id: number,
  input: UpdateApiKeyInput,
): Promise<void> {
  await request<void>({
    method: 'PATCH',
    url: API.apikey.detail(id),
    data: input,
  });
}

/** 删除 API Key。 */
export async function deleteApiKey(id: number): Promise<void> {
  await request<void>({ method: 'DELETE', url: API.apikey.detail(id) });
}
